export default "<h1>Typography 字体</h1>\n<p>统一字体规范，力求在各个操作系统上都有最佳的展示效果。</p>\n"